// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLumeraBelly_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M40 8V0H36C29.4827 0.0546585 23.815 3.67225 20.8491 9H13V19L13 19.0015L19.1019 17.499C19.1773 17.4843 19.2528 17.4676 19.3284 17.4487L20.765 17.0895L22 16.7854V18.4066L11 21.037V27H9V43H9.76389C9.28885 43.5308 9 44.2316 9 45C9 46.6569 10.3431 48 12 48C13.6569 48 15 46.6569 15 45C15 44.2316 14.7111 43.5308 14.2361 43H21.7639C21.2889 43.5308 21 44.2316 21 45C21 46.6569 22.3431 48 24 48C25.6569 48 27 46.6569 27 45C27 44.2316 26.7111 43.5308 26.2361 43H27V41H19V27.5913L29 22.0913V16.7327L24 17.9283V16.2808L25.3284 15.9487C26.8985 15.5561 28 14.1454 28 12.527C28 10.5791 26.4209 9 24.473 9H23.1863C25.9564 4.78378 30.728 2 36.1498 2C36.3171 2 36.4838 2.00265 36.6498 2.00791V2H38L38 8H35V15.6931L31.5 16.6309V18.7014L35 17.7636V20H36L37.5 21H40.5L42 20H43V17.7657L46.5 18.7036V16.633L43 15.6952V8H40ZM17 41V26.4087L27 20.9087V19.2673L13 22.6152V29H11V41H17ZM41 10H37V18H41V10ZM24.8434 14.0084L19 15.4692V15.4871L15 16.4967V11H24.473C25.3163 11 26 11.6837 26 12.527C26 13.2277 25.5231 13.8384 24.8434 14.0084ZM13 45C13 45.5523 12.5523 46 12 46C11.4477 46 11 45.5523 11 45C11 44.4477 11.4477 44 12 44C12.5523 44 13 44.4477 13 45ZM24 46C24.5523 46 25 45.5523 25 45C25 44.4477 24.5523 44 24 44C23.4477 44 23 44.4477 23 45C23 45.5523 23.4477 46 24 46Z" class="svg-bg"/>
  <path d="M1 1V13H11V11H3L3 3H17V7H19V1H1Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLumeraBelly is a generated icon component.
 */
let IconMedLumeraBelly = IconMedLumeraBelly_1 = class IconMedLumeraBelly extends IconBaseElement {
    render() {
        return html `${IconMedLumeraBelly_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLumeraBelly.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s48IconSvg],
    ['s72', _s48IconSvg],
    ['s80', _s48IconSvg],
]);
IconMedLumeraBelly = IconMedLumeraBelly_1 = __decorate([
    customElement('zui-icon-med-lumera-belly')
], IconMedLumeraBelly);
export { IconMedLumeraBelly };
